import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home, NotFound } from './routes';
import { FPLNavbar } from './components/Navbar';
import { Footer } from './components/Footer';

function App() {
  return (
    <BrowserRouter>
      <FPLNavbar />
      <Routes>
        <Route index element={<Home />}/>
        <Route path='*' element={<NotFound />}/>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
